import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ContentSections from './components/ContentSections';
import ArticlePreviewSection from './components/ArticlePreviewSection';
import Footer from './components/Footer';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'Kakobuy Polska Spreadsheet Hub',
      url: 'https://kakobuypolska.study',
      description: 'Największa baza najlepszych produktów Kakobuy – sprawdzone linki, sneakersy, streetwear i poradniki dla polskich kupujących.',
      inLanguage: 'pl-PL',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://kakobuypolska.study/?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'Kakobuy Polska Spreadsheet Hub',
      url: 'https://kakobuypolska.study',
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
      description: 'Niezależny przewodnik informacyjny dla polskich kupujących korzystających z Kakobuy – arkusze produktów, poradniki zakupowe i bezpieczeństwo.',
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
  ],
};

export default function Home() {
  const { t } = useTranslation();

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageJsonLd) }}
      />
      <Navbar />

      <main>
        <Hero />

        <div className="w-full bg-background-50 border-b border-background-200/70">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-3 flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {[
              { key: 'trust_updated', icon: 'ri-refresh-line' },
              { key: 'trust_guides', icon: 'ri-guide-line' },
              { key: 'trust_compare', icon: 'ri-scales-3-line' },
              { key: 'trust_safety', icon: 'ri-shield-check-line' },
            ].map((item) => (
              <div key={item.key} className="flex items-center gap-2 text-xs md:text-sm text-foreground-700">
                <i className={`${item.icon} w-4 h-4 flex items-center justify-center text-accent-500`}></i>
                <span>{t(item.key)}</span>
              </div>
            ))}
          </div>
        </div>

        <CategorySection />
        <ContentSections />
        <ArticlePreviewSection />
      </main>

      <Footer />
    </>
  );
}